import settings from 'shared/settings';
import http from 'shared/utils/http';


const { catalog } = settings.hosts;


export default function () {
  return http.get(`${catalog}catalog/users/deals`);
}



// WEBPACK FOOTER //
// ./src/shared/utils/adapters/payments/items-deal-info.js